import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface VerifiedTdaPassenger {
  mdTicketTypeId: string;
  passengerIdentityNo: string;
  firstName: string;
  lastName: string | null;
  identityType: string;
}

interface TdaState {
  verifiedTdaPassengers: VerifiedTdaPassenger[];

  setVerifiedTdaPassengers: (
    passengers: VerifiedTdaPassenger[],
  ) => void;

  clearVerifiedTdaPassengers: () => void;
}

export const useTdaStore = create<TdaState>()(
  persist(
    (set) => ({
      verifiedTdaPassengers: [],

      setVerifiedTdaPassengers: (passengers) =>
        set({
          verifiedTdaPassengers: passengers,
        }),

      clearVerifiedTdaPassengers: () =>
        set({
          verifiedTdaPassengers: [],
        }),
    }),
    {
      name: "tda-storage",
    },
  ),
);